const PORTFOLIO_DATA = [
  {
    id: "1",
    name: "Restaurant Landing Page",
    imgUrl: "https://i.postimg.cc/3wmZsJ3J/Screenshot-64.png",
    webUrl: "https://georgia-restro.netlify.app/",
  },
  {
    id: "2",
    name: "Agency Landing Page",
    imgUrl: "https://i.postimg.cc/tR1KYFRs/Screenshot-82.png",
    webUrl: "https://24x7agency.netlify.app/",
  },

  {
    id: "3",
    name: "UniCraft Landing Page",
    imgUrl:
      "https://i.postimg.cc/MpKgyzFp/Screenshot-from-2023-12-18-17-00-28.png",
    webUrl: "https://unicraft-astro.netlify.app/",
  },
  {
    id: "4",
    name: "Questions",
    imgUrl: "https://i.postimg.cc/DyKPSXTS/Questions.png",
    webUrl: "https://product-management-interview-questions-page.vercel.app/",
  },
  {
    id: "5",
    name: "React-Robos",
    imgUrl: "https://i.postimg.cc/W3K0Why4/Screenshot-59.png",
    webUrl: "https://reactrobos.netlify.app/",
  },
  {
    id: "6",
    name: "Refhire",
    imgUrl: "https://i.postimg.cc/bwK0f7w7/Screenshot-2025-06-25-105912.png",
    webUrl: "https://refhire.xyz",
  },

  {
    id: "7",
    name: "Dropout Story",
    imgUrl: "https://i.postimg.cc/Xq0dnK1K/dropout-sory.png",
    webUrl: "https://dropout-stories.vercel.app/",
  },
  {
    id: "8",
    name: "Acme Dashboard",
    imgUrl: "https://i.postimg.cc/hPJpmBJY/acme-dashboard.png",
    webUrl: "https://acme-next-js-rosy.vercel.app/",
  },
  {
    id: "9",
    name: "Products Listing Page",
    imgUrl: "https://i.postimg.cc/g2NpvdCj/Screenshot-91.png",
    webUrl: "https://scandiwebjuniordevproducts.000webhostapp.com/",
  },
  {
    id: "10",
    name: "Solana Micro Blogs! Devnet",
    imgUrl:
      "https://i.postimg.cc/hG54cM0P/Screenshot-from-2023-10-10-10-12-19.png",
    webUrl: "https://solana-micro-blogs.netlify.app/",
  },
  {
    id: "11",
    name: "Air Drop Solana",
    imgUrl: "https://i.postimg.cc/W15NB5nJ/Screenshot-82.png",
    webUrl: "https://air-drop-sol.netlify.app/",
  },
  {
    id: "12",
    name: "Display NFT's",
    imgUrl: "https://i.postimg.cc/RVTCnHH1/Screenshot-403.png",
    webUrl: "https://display-nfts-solana.vercel.app",
  },
];

export default PORTFOLIO_DATA;
